import { Divider } from '@mui/material'
import PointsSvg from 'images/Points.svg'
import React from 'react'
import Loader from '@components/Loader'
import { Link } from 'react-router-dom'
import { ACCOUNT_CREATE_URL } from '../../urls'
import { Trans, useTranslation } from 'react-i18next'
import FormattedDate from '@components/FormattedDate'

interface RewardsProps {
  earnPoints: number
  isAuthenticated: boolean
  loading: boolean

  handleSignIn(): void
}

const Rewards: React.FC<RewardsProps> = ({ earnPoints, isAuthenticated, loading, handleSignIn }) => {
  const { t } = useTranslation()

  if (!(earnPoints > 0)) {
    return null
  }

  return (
    <div>
      <div className='p-20 flex justify-between'>
        <p className='text-bold text-lg m-0 leading-tight'>{t('rewards', 'Rewards')}</p>
        <span>
          <Trans
            i18nKey='asOfDate'
            defaults={`as of <date/>`}
            components={{ date: <FormattedDate value={new Date().toISOString()} /> }}
          />
        </span>
      </div>
      <Divider />
      <div className='p-20'>
        <div className='flex items-center text-13'>
          <div className='w-40 mr-10'>
            <img src={PointsSvg} alt='Points' className='max-w-full' />
          </div>
          <div className='flex-1'>
            {!isAuthenticated && (
              <span className='text-gray-800'>
                <Trans
                  i18nKey='signInToEarnPoints'
                  defaults='<a>Sign in</a> to earn <strong>{{earnPoints}}</strong> points with this purchase!'
                  values={{ earnPoints: earnPoints }}
                  count={earnPoints}
                  components={{
                    a: (
                      <Link
                        className='text-blue no-underline'
                        to={ACCOUNT_CREATE_URL}
                        onClick={e => {
                          e.preventDefault()
                          handleSignIn()
                        }}
                      />
                    ),
                    strong: <strong className='text-black' />,
                  }}
                />
              </span>
            )}
            {isAuthenticated && (
              <span className='text-gray-800'>
                <Trans
                  i18nKey='youEarnPointsWithPurchase'
                  defaults={`Good news! You'll earn <strong><loader/>{{earnPoints}}</strong> points with this purchase!`}
                  values={{ earnPoints: earnPoints }}
                  count={earnPoints}
                  components={{
                    strong: <strong className={`relative text-black ${loading ? ' opacity-0' : ''}`} />,
                    loader: (
                      <Loader
                        className='spinner spinner--xs'
                        type='ThreeDots'
                        color='#333'
                        visible={loading}
                        height={100}
                        width={100}
                      />
                    ),
                  }}
                />
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Rewards
